import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { Statement } from '@/customTypes/chatStory';
import TextWithEffect from './TextWithEffect';

interface IScript {
  statement: Statement;
}

const Script = ({ statement }: IScript) => {
  return (
    <div
      css={css`
        ${script}
        background-color: ${statement?.effect?.backgroundColor};
        border: 1px solid ${statement?.effect?.edgeColor || 'transparent'};
      `}
    >
      <TextWithEffect fullWidthText={statement} />
    </div>
  );
};

const script = `
  text-align: center;
  font-size: 1em;
  color: ${theme.colors.gray700};
  padding: 1em;
`;

export default Script;
